import * as React from "react";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import {
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  Dialog,
  FormGroup,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import { Alert } from "@mui/material";
import AlertBox from "../CommonComponent/AlertBox";
import { useEffect, useState } from "react";
import Snackbar from "@mui/material/Snackbar";

import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { AppSettings } from "../../AppSettings";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import TariffHelper from "../../Helper/TariffHelper";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import { Message } from "../../Interface/Message";
import Grid from "@mui/material/Grid";
import AppHelper from "../../Helper/AppHelper";
import { useNavigate } from "react-router-dom";
import FlipCameraAndroidIcon from "@mui/icons-material/FlipCameraAndroid";
import Loader from "../Loader";
import dtmsImg from "../../images/masterData.png"

export default function TariffData() {
  const [tariffIDs, setTariffIDs] = React.useState("");
  const [tariffRequestType, setTariffRequestType] = React.useState(
      [
          { id: "0", value: "Tariff_Header", label: "Tariff Header", checked: false },
          { id: "1", value: "Tariff_Entity_Service", label: "Tariff Entity - Service", checked: false },
          { id: "2", value: "Tariff_Entity_Service_Equipment", label: "Tariff Entity - Service Equipment", checked: false },
          { id: "3", value: "Tariff_Entity_Charges", label: "Tariff Entity - Charges", checked: false },
          { id: "4", value: "Tariff_Entity_Charges_Options", label: "Tariff Entity - Charges Options", checked: false },
          { id: "5", value: "Tariff_Entity_Rate", label: "Tariff Entity - Rate", checked: false },
          { id: "6", value: "Tariff_Entity_Rate_Options", label: "Tariff Entity - Rate Options", checked: false },
          { id: "7", value: "Tariff_Entit_Lane", label: "Tariff Entity - Lane", checked: false },
          { id: "8", value: "Range_Codes", label: "Range Codes", checked: false },
          { id: "9", value: "Zones", label: "Zones", checked: false },
          { id: "10", value: "Tariff_Entity_Surcharges", label: "Tariff Entity - Surcharges/Discounts Rates", checked: false },
          { id: "11", value: "Tariff_Freight_RatedAsFreight_Class", label: "Tariff Entity - Freight Class X-Ref & Rates as Freight Class", checked: false },
      ]
  );

  const [messageObj, setMessageObject] = useState<any>();
  const [showDownloadSection, setDownloadSection] = React.useState(false);
  const [requiredfieldError, setRequiredfieldError] = useState(false);
  const [openDialog, setOpenopenDialog] = React.useState(false);
  const [openLoader, setOpenloader] = React.useState(false);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [alertBoxmsg, setAlertBoxmsg] = useState<Message>({
    Type: "",
    Text: "",
  });
  const navigate = useNavigate();

  function handleValidateTariffIds() {
    setRequiredfieldError(false);
    console.log(process.env);

    if (
      tariffIDs == undefined ||
      tariffIDs == "" ||
      tariffIDs == null ||
      tariffIDs.trim().length == 0
    ) {
      setRequiredfieldError(true);
    } else {
      let apiUrl =
        AppSettings.API_URL + "Tariff/ValidateTariff?tariffIds=" + tariffIDs;

      setOpenloader(true);

      fetch(apiUrl, AppHelper.requestOptions("GET"))
        .then((response) => {
          console.log(response);
          if (!response.ok) {
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
          }
          return response.json();
        })
        .then((data) => {
          setMessageObject(data);    
          if (data.errors.length > 0) {
            setOpenopenDialog(true);
          } else {
            setDownloadSection(true);
          }
        })
        .catch((err) => {
          if (err.message === "Failed to fetch") {
            navigate("/SessionExpired");
          } else {
            //API Error.
            showAPIError(err.message);
          }
        })
        .finally(() => {
          setOpenloader(false);
        });
    }
  }

  useEffect(() => {
   // UserHelper.isAuthorized("AccessTariffData");
  }, []);

  function showAPIError(error: string) {
    let msg: Message = {
      Text: error,
      Type: "Error",
    };

    setAlertBoxmsg(msg);
    setOpenSnackbar(true);
    setTimeout(() => {
      setOpenSnackbar(false);
    }, 3000);
  }

  function handleCloase() {
    setOpenopenDialog(false);
    setMessageObject(null);
  }

  function handleReEnterTariff() {
    setTariffIDs("");
    setDownloadSection(false);
    }

  function handleDownload() {
    if (
      tariffIDs == undefined ||
      tariffIDs == "" ||
      tariffIDs == null ||
      tariffIDs.trim().length == 0
    ) {
      setRequiredfieldError(true);
      return;
    }

    let tariffTypes = "";
      tariffRequestType.forEach((tariff) => {
          if (tariff.checked === true) {
              if (tariffTypes === "")
                  tariffTypes = tariff.value;
              else
                  tariffTypes = tariffTypes + "," + tariff.value;
          }
      });

      if (tariffTypes === "") {
          setRequiredfieldError(true);
          return;
      }

    setOpenloader(true);
    setRequiredfieldError(false);
    TariffHelper.DownloadTariffData(tariffTypes, tariffIDs).then(
      (isDownloaded) => {
        setOpenloader(false);
        let msg: Message = {
          Text: "",
          Type: "",
        };

        if (isDownloaded) {
          msg = {
            Text: "File downloaded successfully!",
            Type: "Success",
          };
        } else {
          msg = {
            Text: "Download Failed!",
            Type: "Error",
          };
        }
        setAlertBoxmsg(msg);
        setOpenSnackbar(true);
        setTimeout(() => {
          setOpenSnackbar(false);
        }, 3000);
      }
    );
  }

  const handleCloseSnackbar = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setOpenSnackbar(false);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      tariffRequestType[Number(event.target.id)].checked = event.target.checked;
      setTariffRequestType(tariffRequestType);
  };

  return (    
    <div className="page-container">
	    <div className="add-details">
		    <Loader value={openLoader}></Loader>  
			    <Container component="main" maxWidth="md">
				    <CssBaseline/>                          
                    <Grid container spacing={2}>
                          <Grid item xs={10}>
                              <Box sx={{ marginTop: 3, display: "flex", flexDirection: "column", }}>                           
                                  <Typography
              component="h1"
              variant="h5"
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
              }}
            >
         
              <b>Tariff Management</b>
            </Typography>
                                  <Box component="form" noValidate sx={{ mt: 1 }}>

                                      {!showDownloadSection && (
                                          <Grid container spacing={2}>
                                              <Grid item xs={8}>
                                                  <TextField id="Street" label="Tariff IDs" variant="outlined" onChange={(e) => setTariffIDs(e.target.value)}
                                                      required
                                                      fullWidth
                                                      multiline
                                                      error={requiredfieldError}
                                                      helperText={
                                                          requiredfieldError ? "Error : Field is required" : ""
                                                      }
                                                  />
                                              </Grid>
                                              <Grid item xs={4}>
                                                  <Button variant="contained" size="large" startIcon={<LabelImportantIcon />}
                                                      onClick={handleValidateTariffIds}> Validate ID(s)</Button>
                                              </Grid>
                                          </Grid>
                                      )}

                                      {showDownloadSection   && (
                                          <>
                                              <Grid container spacing={2}>
                                                  <Grid item xs={12}>
                                                      <Alert severity="success">Valid TariffID(s)</Alert>
                                                  </Grid>
                                                  <Grid item xs={9}>
                                                      <TextField id="Street" variant="outlined" fullWidth multiline disabled value={tariffIDs} />
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                 
                                                      <Button variant="contained" size="large" onClick={handleReEnterTariff} startIcon={<FlipCameraAndroidIcon />}>
                                                          Reset  
                                                      </Button>
                                                  </Grid>
                                              </Grid>
                                              <br />
                                              <Grid container spacing={2}>
                                                  <Grid item xs={9}>
                                                      <Typography variant="h5" component="div">
                                                          Select Entity(s){"   "}  
                                                      </Typography>
                                                     
                                                  </Grid>
                                                  <Grid item xs={3}>
                                                  <Button variant="contained" size="medium" onClick={handleDownload} startIcon={<DownloadForOfflineIcon />}>
                                                          Download 
                                                      </Button>
                                                  </Grid>
                                              </Grid>
                                              <FormGroup>
                                                  {tariffRequestType.map((tariff) => (
                                                      <FormControlLabel value={tariff.value} control={<Checkbox key={tariff.id} onChange={handleChange} id={tariff.id} />}
                                                          label={tariff.label}
                                                      />
                                                  ))}
                                              </FormGroup>
                                          </>
                                      )}

                                  </Box>
                              </Box>
                          </Grid>
                    </Grid>
                </Container>
      
            <Dialog
                open={openDialog}
                keepMounted
                aria-describedby="alert-dialog-slide-description"
                sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                    width: "100%",
                    maxWidth: "850px", // Set your width here
                    },
                },
                }}
            >
                <DialogTitle>{"Tariff details"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description"/>
                        {messageObj && (
                            <Stack spacing={2} pt={2}> {messageObj.successes.length> 0 && (
                                <Alert severity="success">{messageObj.successes}</Alert>
                            )}

                            {messageObj.errors.length > 0 && (
                                <Alert severity="error">
                                {messageObj.errors}                                
	                            </Alert>
                            )}
                            </Stack>
                        )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloase}>Close</Button>
                </DialogActions>
             </Dialog>

            <Snackbar sx={{ width:"100%" }} open={openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
	            <div>
		            <AlertBox value={alertBoxmsg}></AlertBox>{" " }
	            </div>
            </Snackbar>
        </div>
    </div>
  );
}
